import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { gatewayOfferApi } from './gateway-offer-api';
import type { SearchOfferResponse } from './offer-api';
import { offerKeys } from './offer-keys';

const fetchOffer = async (phone?: string | null) => {
  if (!phone) {
    return { status: 'NOT_FOUND' } as SearchOfferResponse;
  }

  try {
    const offer = await gatewayOfferApi.getByPhone(phone);
    return offer;
  } catch (_error) {
    return { status: 'NOT_FOUND' } as SearchOfferResponse;
  }
};

export const useSearchOfferByPhone = (
  params: { phone?: string | null },
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: offerKeys.offerByPhone(params?.phone),
    queryFn: async () => {
      return fetchOffer(params?.phone);
    },
    ...options,
  });
};

export const useMutateAsyncSearchOfferByPhone = (
  phone?: string | null,
  options?: UseMutationOptions<SearchOfferResponse, Error, string>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (phoneNumber: string) => {
      return fetchOffer(phoneNumber);
    },
    onSuccess: (data) => {
      queryClient.setQueryData<Partial<SearchOfferResponse>>(
        offerKeys.offerByPhone(phone),
        data
      );
    },
    ...options,
  });
};
